import React from 'react';

import { Loader2Icon } from 'lucide-react';

const withSuspense = <P extends object>(Component: React.ComponentType<P>, Fallback?: React.ComponentType) => {
  const displayName = Component.displayName || Component.name || 'Component';

  const WrappedComponent = (props: P) => (
    <React.Suspense fallback={Fallback ? <Fallback /> : <Loader2Icon className="animate-spin" />}>
      <Component {...props} />
    </React.Suspense>
  );

  WrappedComponent.displayName = `withSuspense(${displayName})`;

  return WrappedComponent;
};

export default withSuspense;
